import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined"
import Button from "@mui/material/Button"
import PropTypes from "prop-types"
import { useState } from "react"

import BookMeetingDialog from "./BookMeetingDialog"

export default function MeetingsBookButton({ onBooked }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="contained"
        startIcon={<EventAvailableOutlinedIcon />}
        onClick={() => setIsOpen(true)}
      >
        Book meeting
      </Button>
      <BookMeetingDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onBooked={onBooked}
      />
    </>
  )
}

MeetingsBookButton.propTypes = {
  onBooked: PropTypes.func,
}
